export default function useMetaTitle(title: MaybeRefOrGetter<string>) {
	useHead(computed(() => {
		const resolvedTitle = toValue(title);

		return {
			title: resolvedTitle,
			meta: [{property: 'og:title', content: resolvedTitle}],
		};
	}));
}
